import React, { useEffect, useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Select, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";

import * as com from "../../Common";
import * as act from "../../Store/actions";
import { checkAccess } from "../../Auth";
import "./common.css";
import { UR_Owner } from "../../State";

interface CurrentStatusProps {
  currentStatus: string;
  currentStage: string;
  loanID: string;
  wrapClassName?:string;
  boxClassName?:string;
  onChange?: Function;
  DispatchFn?: Function;
  isDispatch?: Boolean;
  value?:string;
  colNum?:number;
  /** When set, status options use this purpose instead of Redux application.property.purpose */
  loanPurpose?: string;
}

const CurrentStatus = ({ currentStatus,currentStage:stage,colNum=3, loanID,wrapClassName,boxClassName ,value, onChange=()=>{}, isDispatch=true, DispatchFn=act.UpdateApplicationAttribute, loanPurpose}: CurrentStatusProps) => {
  const appStage = useSelector(
    (state: any) => state.application.currentStage
  );
  const currentStage = stage ?? appStage
  const dispatch = useDispatch();
  const updateApplicationAttribute = (t, verb) => {
    dispatch(DispatchFn(t, verb));
  };

  const reduxPurpose: string = useSelector(
    (state: any) => state.application?.property?.purpose
  );
  const purpose = loanPurpose ?? reduxPurpose
  const handleCurrentStatusChange = (
    loanID: string,
    newCurrentStatus: string,
    isFirst:boolean=false
  ) => {
    let token = sessionStorage.getItem("ZeitroA");
    let body = {
      LoanID: loanID,
      Key: "currentStatus",
      Value: newCurrentStatus,
      IsAdmin: checkAccess([UR_Owner]) ? true : false,
    };
    fetch("/los/updatepipeline", {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          return;
        }
        isDispatch && updateApplicationAttribute(newCurrentStatus, "currentStatus");
        onChange(newCurrentStatus,isFirst);
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  };

  const items = com.CurrentStatusUtils.getStatusesByStage(
    currentStage,
    purpose
  ).map(({ code, name }, idx) => {
    return {
      value: name,
      key: code,
      label: <div>{com.CurrentStatusUtils.getStatusName(name)}</div>,
    };
  });

  const [statusToDisplay, setStatusToDisplay] = useState(currentStatus);

  useEffect(() => {
    const applicableStatuses = com.CurrentStatusUtils.getStatusesByStage(
      currentStage,
      purpose
    );
    if (!applicableStatuses.length) {
      setStatusToDisplay(currentStatus);
      return;
    }
    if (!applicableStatuses.some((status) => status.name === currentStatus)) {
      const firstApplicableStatus = applicableStatuses[0].name;
      setStatusToDisplay(firstApplicableStatus);
      handleCurrentStatusChange(loanID, firstApplicableStatus, true);
    } else {
      setStatusToDisplay(currentStatus);
    }
  }, [currentStatus, currentStage, purpose]);

  return (
    <div className={["summaryLoansStatusContainer",`col-${colNum}`,wrapClassName].join(' ')}>
      <div
        className={['loansStatus',boxClassName].join(' ')}
        style={{
          borderColor:
            com.CurrentStatusUtils.getStatusBorderColor(currentStatus),
          backgroundColor:
            com.CurrentStatusUtils.getStatusBackgroundColor(currentStatus),
        }}
      >
        <Select
          style={{
            backgroundColor:
              com.CurrentStatusUtils.getStatusBackgroundColor(currentStatus),
            color: com.CurrentStatusUtils.getStatusTextColor(currentStatus),
            border: "none",
          }}
          value={com.CurrentStatusUtils.getStatusName(statusToDisplay)}
          onChange={(value) => {
            handleCurrentStatusChange(loanID, value);
          }}
          options={items}
          suffixIcon={
            <img src="/images/stepper-menu-arrow-down.svg" alt="down-arrow" />
          }
        />
      </div>
    </div>
  );
};

export default CurrentStatus;
